import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { loadingOverlayStates } from '../../hooks/useLoadingOverlayHook';

const overlayActions = mapDefaultValuesToActions(loadingOverlayStates);

export default reduxReducerHelper(overlayActions, loadingOverlayStates);
